import * as React from "react";
const SvgLightningBolt = (props) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 100, viewBox: "0 0 48 100", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28.3594 40.7412H47.0371L12.9629 100L18.6777 59.2588H0L34.0742 0L28.3594 40.7412Z" }));
export default SvgLightningBolt;
